const types = {
	landing: 'landing',
	transit: 'transit'
};

const locale = {
	ru: {
		landing: 'лендинг',
		transit: 'транзитка'
	},
	en: types,
	uk: types,
	de: {
		landing: 'Landing',
		transit: 'Transit'
	},
	vi: types,
	th: {
		landing: 'ร้านค้าออนไลน์',
		transit: 'การเปลี่ยนถ่ายข้อมูล การเปลี่ยนเครื่อง	'
	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/offer-domain-types.js